import React from 'react';
import { Logo } from './Logo';
import { CheckoutButton } from './CheckoutButton';
const links = [{
  label: "What's inside",
  href: '#inside'
}, {
  label: 'Nutrition Check',
  href: '#nutrition-check'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Nav() {
  return <header className="sticky top-0 z-50 border-b border-orangey-100 bg-cream/90 backdrop-blur-md" data-id="element-96" data-mp="1b1nis71jg2qb">
      <nav aria-label="Main" className="mx-auto flex w-full max-w-5xl items-center justify-between gap-6 px-5 py-3 sm:px-8" data-id="element-97" data-mp="1fynogguh73gw">
        <a href="#top" aria-label="Pawsy Companion home" data-id="element-98" data-mp="1kwflfp9z9fry">
          <Logo data-id="element-99" data-mp="1pqtl43voa92f" />
        </a>

        <ul className="hidden items-center gap-7 text-sm font-semibold text-ink-500 lg:flex" data-id="element-100" data-mp="1prlc11ebrimd">
          {links.map(link => <li key={link.href} data-id="element-101" data-mp="1yqoymfcpag5m">
              <a className="transition-colors hover:text-orangey-700" href={link.href} data-id="element-102" data-mp="1yrhuume19n9i">
                {link.label}
              </a>
            </li>)}
        </ul>

        <CheckoutButton size="md" className="hidden sm:inline-flex" data-id="element-103" data-mp="1y66ztd1vso6c">
          Build My Plan — $29
        </CheckoutButton>
      </nav>
    </header>;
}